// extracted by mini-css-extract-plugin
module.exports = {"assign_groups_container":"styles_assign_groups_container__4mzYx","assign_groups_container__group_item":"styles_assign_groups_container__group_item__22CBX"};